<template>
    <div class="tabs">
        <div class="tabs-bar">
            <div
            :class="tabCls(item)"
            v-for="(item, index) in navList"
            :key="item.name"
            @click.self="handleChange(index)">
            {{ item.label }}
            <template v-if="item.closable">
            <a href="#" class="del" v-show="item.name===currentValue"
            @click="handleClose(item,index)"
            >x</a>
            </template>
            </div>
        </div>
        <div class="tabs-content">
            <slot></slot>
        </div>
    </div>

</template>
<script>
export default {
    props:{
        value:{
            type:[String, Number]
        },
    },
    data(){
        return{
            currentValue:this.value,
            navList:[]
        }
    },
    methods:{
        handleClose(item,index){
            this.navList.splice(index,1);
            //console.log(this.navList.length);
            var name = item.name;
            //console.log(name)
            this.handleChange(0)
            this.$emit('on-close',name);            
        },
        tabCls(item){
            return[
                'tabs-tab',
                {
                    'tabs-tab-active':item.name === this.currentValue
                }
            ]
        },
        getTabs(){
            return this.$children.filter(function(item){
                return item.$options.name === 'pane';
            });
        },
        updateNav(){
            this.navList=[];
            var _this = this;

            this.getTabs().forEach(function(pane, index){
                _this.navList.push({
                    label:pane.label,
                    name: pane.name || index,
                    closable:pane.closable
                });
                if(!pane.name) pane.name = index;
                if(index === 0){
                    if(!_this.currentValue){
                        _this.currentValue = pane.name || index;
                    }
                }
            });
            this.updateStatus();
        },
        updateStatus(){
            var tabs = this.getTabs();
            var _this = this;

            tabs.forEach(function(tab){
                return tab.show = tab.name === _this.currentValue;
            })
        },
        handleChange(index){
            if(this.navList.length){
            var nav = this.navList[index];            
            var name = nav.name;
            //console.log(name)
            this.currentValue = name;
            this.$emit('input',name);
            this.$emit('on-click',name);
            }
        }
    },
    watch:{
        value(val){
            this.currentValue = val;
        },
        currentValue(){
            this.updateStatus();
        }
    }
}
</script>
<style>
.tabs{
    font-size: 14px;
    color: #657180;
}
.tabs-bar::after{
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #d7dde4;
    margin-top: -1px;
}
.tabs-tab{
    display: inline-block;
    padding: 4px 16px;
    margin-right: 6px;
    background: #fff;
    border: 1px solid #d7dde4;
    cursor: pointer;
    position: relative;
}
.tabs-tab-active{
    color: #3399ff;
    border-top: 1px solid #3399ff;
    border-bottom: 1px solid #fff;
}
.tabs-tab-active::before{
    content: '';
    display: block;
    height: 1px;
    background: #3399ff;
    position: absolute;
    top:0;
    left: 0;
    right: 0;
}
.tabs-content{
    padding: 8px 0;
}
.tabs-bar .tabs-tab .del{
    float: right;
    color: #889db6;
    text-decoration: none;    
}
.tabs-bar .tabs-tab a:hover{
    color:red;
}
</style>
